/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SegmentParameter
 */
export interface SegmentParameter {
    /**
     * The unique identifier of the segment parameter
     * @type {string}
     * @memberof SegmentParameter
     */
    id?: string | null;
    /**
     * The name of the segment parameter
     * @type {string}
     * @memberof SegmentParameter
     */
    name: string;
    /**
     * The value of the segment parameter
     * @type {number}
     * @memberof SegmentParameter
     */
    value?: number | null;
}

/**
 * Check if a given object implements the SegmentParameter interface.
 */
export function instanceOfSegmentParameter(value: object): value is SegmentParameter {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SegmentParameterFromJSON(json: any): SegmentParameter {
    return SegmentParameterFromJSONTyped(json, false);
}

export function SegmentParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): SegmentParameter {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function SegmentParameterToJSON(json: any): SegmentParameter {
    return SegmentParameterToJSONTyped(json, false);
}

export function SegmentParameterToJSONTyped(value?: SegmentParameter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'value': value['value'],
    };
}

